import { render, staticRenderFns } from "./ActiveOpportunities.vue?vue&type=template&id=11cb07e1&scoped=true&"
import script from "./ActiveOpportunities.vue?vue&type=script&lang=js&"
export * from "./ActiveOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOpportunities.vue?vue&type=style&index=0&id=11cb07e1&prod&lang=css&"
import style1 from "./ActiveOpportunities.vue?vue&type=style&index=1&id=11cb07e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cb07e1",
  null
  
)

export default component.exports